export { default } from './Magnet'
